<template>
  <b-card>
    <DetailLowMovingStock />
  </b-card>
</template>

<script>
/**
 * Component wrapper untuk page detail tagihan dari halaman Tagihan
 *
 * Component ini memberikan akses kepada user untuk melihat detail tagihan dengan url /keuangan/tagihan/:id
 * dan menampilkan detail tagihan low moving stock menggunakan component DetailLowMovingStock.
 */
import DetailLowMovingStock from './detail/low-moving-stock/DetailLowMovingStock.vue'

export default {
  name: 'Detail',
  components: {
    DetailLowMovingStock,
  },
}
</script>
